<template>
	<div id="app">
    	<router-view v-if="isRouterAlive" />
  	</div>
</template>

<script>
	export default {
	 	name: 'App',
	  	provide(){
	  		return {
	  			reload: this.reload
	  		}
	  	},
	  	data(){
	  		return {
	  			isRouterAlive: true
	  		}
	  	},
	  	methods: {
	  		reload(){
	        	this.isRouterAlive = false
	        	this.$nextTick(function(){
	            	this.isRouterAlive = true
	        	})
	  		}
	  	}
	}
</script>

<style>
/*#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

}*/

*:focus{ outline: none !important}
html, body, #app{
 	width: 100%; 
	height: 100%;
}
*{
  padding:0;
  margin:0;
}
.el-card__header{
	padding:10px 20px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue